import React, { useState, useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Camera, MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";
import { MagneticButton } from "@/components/pp/Shared";
import { track } from "@/lib/api";
import { scrollTo } from "@/components/pp/Navbar";

export default function FinalCTA() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-120px" });
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (inView) { setFlash(true); const t = setTimeout(() => setFlash(false), 320); return () => clearTimeout(t); }
  }, [inView]);

  return (
    <section ref={ref} className="relative py-28 md:py-40 overflow-hidden" data-testid="final-cta">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 60%, rgba(245,158,11,0.14), transparent 55%)" }} />
      {/* flash */}
      <motion.div className="absolute inset-0 bg-white pointer-events-none z-[3]"
        initial={{ opacity: 0 }} animate={{ opacity: flash ? 0.85 : 0 }} transition={{ duration: 0.18 }} />

      <div className="pp-container relative z-[2] text-center flex flex-col items-center">
        <motion.div initial={{ scale: 0, rotate: -20 }} animate={inView ? { scale: 1, rotate: 0 } : {}} transition={{ type: "spring", delay: 0.1 }}
          className="h-16 w-16 rounded-2xl pp-glass grid place-items-center mb-8 pp-glow-orange">
          <Camera className="text-[#f59e0b]" size={30} />
        </motion.div>

        <h2 className="font-display uppercase tracking-tighter leading-[0.85] text-[3rem] sm:text-6xl lg:text-8xl text-white">
          <span className="block">Your Brand Deserves</span>
          <span className="block pp-text-gradient">Better Creative.</span>
        </h2>
        <p className="mt-6 max-w-xl text-slate-300 text-base md:text-lg">
          Let's transform your next idea into a memorable brand experience.
        </p>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ delay: 0.35 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <MagneticButton onClick={() => { track("cta_click", { cta: "lets_talk" }); scrollTo("contact"); }}
            data-testid="final-cta-talk"
            className="bg-[#f59e0b] text-black font-semibold uppercase tracking-widest text-sm px-7 py-4 hover:bg-white transition-colors">
            Let's Talk
          </MagneticButton>
          <button onClick={() => { track("cta_click", { cta: "custom_proposal" }); scrollTo("planner"); }}
            data-testid="final-cta-proposal"
            className="border border-white/20 text-white font-semibold uppercase tracking-widest text-sm px-7 py-4 hover:bg-white/5 transition-colors">
            Get a Custom Proposal
          </button>
          <a href={waLink()} target="_blank" rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { location: "final_cta" })}
            data-testid="final-cta-whatsapp"
            className="inline-flex items-center gap-2 text-[#25D366] font-semibold uppercase tracking-widest text-sm px-7 py-4 border border-[#25D366]/30 hover:bg-[#25D366]/10 transition-colors">
            <MessageCircle size={18} /> Chat on WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
}
